import * as React from 'react';
import { useRecordContext } from 'react-admin';
import clsx from 'clsx';

const StatusTags = (props: { source: string; label?: string; sortable?: boolean }) => {
    const record = useRecordContext<any>();
    if (!record) return null;
    if (props.source === 'chapter_status' && !record['chapter_id']) {
        return <></>;
    }
    if (props.source === 'subject_status' && !record['subject_id']) {
        return <></>;
    }
    if (props.source === 'program_status' && !record['program_id']) {
        return <></>;
    }

    const status = record[props.source];
    const getBackgroundColor = () => {
        if (status === 'NEW' || status === 'PENDING' || status === 'DRAFT') return 'bg-blue-500';
        if (status === 'ACTIVE' || status === 'COMPLETED' || status === 'SUCCESS')
            return 'bg-green-500';
        if (
            status === 'IN_ACTIVE' ||
            status === 'FAILED' ||
            status === 'REJECTED' ||
            status === 'CANCELLED'
        )
            return 'bg-red-500';
        if (status === 'BLOCKED' || status === 'LOCKED') return 'bg-black';
        return 'bg-gray-500'; // Default for unmatched statuses
    };

    return (
        <div
            className={clsx(
                'text-white text-xs font-semibold px-2 inline-block py-0.5 capitalize text-center rounded-md whitespace-nowrap',
                getBackgroundColor(),
            )}
        >
            {record[props.source]?.replace('_', ' ')?.toLowerCase()}
        </div>
    );
};
export default StatusTags;
